import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../../util/withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import {Black, Blue3, Grey6} from "../../theme/styles";
import React from "react";
import {Tooltip, Typography} from "@mui/material";
import {formatLocal2} from "../../util/Formatters";
import css_typography from "../Common/css/Typography.module.scss";

class ProjectPlanAuditLogTable extends EnlilTable {

    getCellRenderer(name) {
        if (name === "Column1 Cell") {
            return this.renderColumn1Cell;
        }
        if (name === "Column2 Cell") {
            return this.renderColumn2Cell;
        }
        if (name === "Content Cell") {
            return this.renderContentCell;
        }

        return super.getCellRenderer(name);
    };

    renderColumn1Cell = (___, params, __, _) => {
        let buffer;
        let colorBlue;
        let colorGrey;

        if (this.state.fetchBackgroundOperation) {
            colorBlue = Grey6
            colorGrey = Grey6
            buffer = this.state.previousBuffer
        } else {
            colorBlue = Blue3
            colorGrey = Grey6
            buffer = this.state.buffer
        }

        if (params.row.id > buffer.length - 1) return;

        let content = "--";
        if (buffer[params.row.id].get("CreatedDatetime") !== undefined) {
            content = (
                <div style={{display: "flex", flexDirection: "column", alignContent: "center", marginTop: "-10px"}}>
                    <div style={{fontSize: 14, color: colorBlue, height: "20px"}}>{formatLocal2(buffer[params.row.id].get("CreatedDatetime"))}</div>
                    <div style={{fontSize: 11, color: colorGrey, height: "20px"}}>{buffer[params.row.id].get("CreatedByName")}/{buffer[params.row.id].get("CreatedByEmail")}</div>
                </div>
            )
        }
        return (
            <>{content}</>
        );
    };

    renderColumn2Cell = (___, params, __, _) => {
        let buffer;
        let colorBlue;
        let colorGrey;

        if (this.state.fetchBackgroundOperation) {
            colorBlue = Grey6
            colorGrey = Grey6
            buffer = this.state.previousBuffer
        } else {
            colorBlue = Blue3
            colorGrey = Grey6
            buffer = this.state.buffer
        }

        if (params.row.id > buffer.length - 1) return;

        let content = "--";
        let type = "";
        if (buffer[params.row.id].get("ProjectPlanPhaseMilestoneUSID") !== null) {
            type = "Milestone Event"
        } else if (buffer[params.row.id].get("ProjectPlanPhaseUSID") !== null) {
            type = "Phase Event"
        } else if (buffer[params.row.id].get("ProjectPlanUSID") !== null) {
            type = "Plan Event"
        }

        let modificationType;
        if (buffer[params.row.id].get("ModificationType") === "INSERT") {
            modificationType = "Record Created"
        } else if (buffer[params.row.id].get("ModificationType") === "UPDATE") {
            modificationType = "Record Updated"
        } else if (buffer[params.row.id].get("ModificationType") === "DELETE") {
            modificationType = "Record Deleted"
        }
        content = (
                <div style={{display: "flex", flexDirection: "column", alignContent: "center", marginTop: "-10px"}}>
                    <div style={{fontSize: 14, color: colorBlue, height: "20px"}}>{type}</div>
                    <div style={{fontSize: 11, color: colorGrey, height: "20px"}}>{modificationType}</div>
                </div>
        )
        return (
            <>{content}</>
        );
    };

    renderContentCell = (___, params, __, _) => {
        let buffer;
        let color;

        if (this.state.fetchBackgroundOperation) {
            color = Grey6
            buffer = this.state.previousBuffer
        } else {
            color = Black
            buffer = this.state.buffer
        }

        if (params.row.id > buffer.length - 1) return;

        let changes = [];
        let modifications = buffer[params.row.id].get("Change");

        let keys = Object.keys(modifications);
        keys.forEach(key => {
            changes.push(
                <div key={key} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", borderBottom: "1px solid #EDEFF3"}}>
                    <div style={{whiteSpace: "nowrap", display: "block", color: color, overflow: "hidden", textOverflow: "ellipsis", width: "200px"}}>
                        <Tooltip title={modifications[key]["Field Path"]}>
                            <Typography className={css_typography.DetailData}>{modifications[key]["Field Path"]}</Typography>
                        </Tooltip>
                    </div>
                    <div style={{whiteSpace: "nowrap", display: "block", color: color, overflow: "hidden", textOverflow: "ellipsis", width: "300px"}}>
                        <Tooltip title={modifications[key]["Previous Value"]}>
                            <Typography className={css_typography.DetailData}>{modifications[key]["Previous Value"] ?? "--"}</Typography>
                        </Tooltip>
                    </div>
                    <div style={{whiteSpace: "nowrap", display: "block", color: color, overflow: "hidden", textOverflow: "ellipsis", width: "300px"}}>
                        <Tooltip title={modifications[key]["Next Value"]}>
                            <Typography className={css_typography.DetailData}>{modifications[key]["Next Value"] ?? "--"}</Typography>
                        </Tooltip>
                    </div>
                </div>
            );
        })
        if (params.row.id > buffer.length - 1) return;

        let content = "--";
        content = (
            <div>
                <div key={1} style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", borderBottom: "1px solid #EDEFF3"}}>
                    <div style={{whiteSpace: "nowrap", display: "block", color: color, overflow: "hidden", textOverflow: "ellipsis", width: "200px"}}>
                        <Typography style={{fontSize: "14px", fontWeight: "400", color: "#000000"}}>Field/Attribute</Typography>
                    </div>
                    <div style={{whiteSpace: "nowrap", display: "block", color: color, overflow: "hidden", textOverflow: "ellipsis", width: "300px"}}>
                        <Typography className={css_typography.DetailLabel}>Changed From:</Typography>
                    </div>
                    <div style={{whiteSpace: "nowrap", display: "block", color: color, overflow: "hidden", textOverflow: "ellipsis", width: "300px"}}>
                        <Typography className={css_typography.DetailLabel}>To:</Typography>
                    </div>
                </div>
                <div key={2} style={{display: "flex", flexDirection: "column", overflowY: "auto", height: "300px"}}>
                    {changes}
                </div>
            </div>
        )
        return (
            <>{content}</>
        );
    };

}

export default withNavigate(withAppContext(withBreakpoint(ProjectPlanAuditLogTable)));